var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 489.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fad31c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.65 184.35 106.11 184.35 106.11 204.34 114.65 204.34 114.65 243.08 106.11 243.08 106.11 263.07 114.65 263.07 135.9 263.07 144.02 263.07 144.02 243.08 135.9 243.08 135.9 204.34 144.02 204.34 144.02 184.35 135.9 184.35 114.65 184.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.02 184.35 67.9 184.35 67.9 204.34 72.37 204.34 69.56 219.71 59.9 187.52 59.91 187.47 59.88 187.47 41.16 187.47 41.14 187.47 41.15 187.52 31.66 219.14 28.96 204.34 33.43 204.34 33.43 184.35 25.31 184.35 4.07 184.35 1.15 184.35 1.15 204.34 7.72 204.34 18.44 263.07 18.46 263.07 39.68 263.07 39.71 263.07 50.52 222.6 61.34 263.07 61.65 263.07 82.58 263.07 82.89 263.07 93.61 204.34 100.18 204.34 100.18 184.35 97.26 184.35 76.02 184.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "211.49 184.35 202.95 184.35 202.95 204.34 211.49 204.34 211.49 224.75 182.75 184.35 161.51 184.35 152.97 184.35 152.97 204.34 161.51 204.34 161.51 243.08 152.97 243.08 152.97 263.07 161.51 263.07 182.75 263.07 190.88 263.07 190.88 243.08 182.75 243.08 182.75 218.92 211.49 263.07 232.74 263.07 240.86 263.07 240.86 243.08 232.74 243.08 232.74 204.34 240.86 204.34 240.86 184.35 232.74 184.35 211.49 184.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "618.85 204.34 618.85 184.35 610.73 184.35 589.49 184.35 580.95 184.35 580.95 204.34 589.49 204.34 589.49 224.75 560.75 184.35 539.5 184.35 530.97 184.35 530.97 204.34 539.5 204.34 539.5 243.08 530.97 243.08 530.97 263.07 539.5 263.07 560.75 263.07 568.87 263.07 568.87 243.08 560.75 243.08 560.75 218.92 589.49 263.07 610.73 263.07 618.85 263.07 618.85 243.08 610.73 243.08 610.73 204.34 618.85 204.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "400.18 184.35 380.5 214.65 362.07 184.35 340.82 184.35 332.29 184.35 332.29 204.34 340.82 204.34 340.82 243.08 332.29 243.08 332.29 263.07 340.82 263.07 362.07 263.07 370.19 263.07 370.19 243.08 362.07 243.08 362.07 222.15 374.56 243.08 387.99 243.08 400.18 222.15 400.18 243.08 392.06 243.08 392.06 263.07 400.18 263.07 421.42 263.07 429.96 263.07 429.96 243.08 421.42 243.08 421.42 204.34 429.96 204.34 429.96 184.35 421.42 184.35 400.18 184.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488,184.35H448.7v20h11.93l-16.09,38.74h-6.25v20h32.18v-20h-9.06l1.73-4.38h21.49l1.77,4.38h-7.92v20h43.84v-20h-7.49Zm-18.74,39,4.56-11.53,4.65,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.73,222.15c0,23.58,21.71,42.17,52,42.17,17.81,0,24.21-1.25,24.21-1.25V216.53H281.63v16.24h18.9s-2.81,8.9-11.55,8.9-17.82-4.84-17.82-19.83c0-12.66,9.82-17.5,18.72-17.5,7.37,0,11.11,9.37,11.11,9.37h23V184.35S318,183.1,294.9,183.1,247.73,198.56,247.73,222.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 271.15,
    width: 619.99,
    height: 5,
    transform: "translate(-0.54 0.61) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.1,283.91a1.87,1.87,0,0,0-2.53.78L26.25,304.11l-3.57-7.19,5.56-10.48a1.87,1.87,0,1,0-3.31-1.75l-4.3,8.1-4-8.06a1.88,1.88,0,1,0-3.36,1.67l5.19,10.46-3.85,7.25L5,284.73a1.88,1.88,0,1,0-3.36,1.67l11.25,22.65a1.87,1.87,0,0,0,1.65,1h0a1.87,1.87,0,0,0,1.65-1l4.3-8.1,4,8.06a1.88,1.88,0,0,0,1.66,1h0a1.89,1.89,0,0,0,1.66-1l12-22.65A1.88,1.88,0,0,0,39.1,283.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.2,283.69a1.88,1.88,0,0,0-1.88,1.88v22.64a1.88,1.88,0,1,0,3.75,0V285.57A1.88,1.88,0,0,0,52.2,283.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.9,283.69A1.88,1.88,0,0,0,87,285.57v17.15l-14.14-18.3a1.87,1.87,0,0,0-3.35,1.15v22.64a1.88,1.88,0,1,0,3.75,0V291.06l14.13,18.3a1.88,1.88,0,0,0,1.49.73,1.8,1.8,0,0,0,.6-.1,1.88,1.88,0,0,0,1.27-1.78V285.57A1.88,1.88,0,0,0,88.9,283.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.27,295h-9.69a1.87,1.87,0,1,0,0,3.74h7.68a8.58,8.58,0,0,1-8.77,7.58c-2.31,0-9.84-.68-9.84-9.45,0-6.53,5-9.45,10-9.45a9,9,0,0,1,8.13,5.12,1.87,1.87,0,0,0,3.44-1.48,12.76,12.76,0,0,0-11.57-7.39c-6.83,0-13.74,4.54-13.74,13.2,0,9.74,7.32,13.2,13.59,13.2a12.8,12.8,0,0,0,8.9-3.5v1.62a1.88,1.88,0,1,0,3.75,0V296.89A1.87,1.87,0,0,0,128.27,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.26,287.44a3.59,3.59,0,0,1,3.9,3.76,1.88,1.88,0,0,0,3.75,0,7.35,7.35,0,0,0-7.65-7.5c-5.09,0-8.12,2.8-8.12,7.5,0,5.28,5.25,7.26,7.23,8l1.12.39c2.61.87,3.67,1.43,3.67,3.48,0,1,0,3.28-4.78,3.28a3.72,3.72,0,0,1-2.92-1,3.45,3.45,0,0,1-.6-2.51,1.87,1.87,0,1,0-3.69-.64,6.58,6.58,0,0,0,7.21,7.86c7.7,0,8.53-4.92,8.53-7,0-4.95-3.9-6.26-6.24-7-.33-.11-.67-.22-1-.34-2.88-1.08-4.79-2.26-4.79-4.49C148.89,289.33,149.41,287.44,153.26,287.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.6,287.44a3.58,3.58,0,0,1,3.9,3.76,1.88,1.88,0,0,0,3.75,0,7.35,7.35,0,0,0-7.65-7.5c-5.09,0-8.12,2.8-8.12,7.5,0,5.28,5.25,7.26,7.23,8l1.12.39c2.61.87,3.67,1.43,3.67,3.48,0,1,0,3.28-4.78,3.28a3.72,3.72,0,0,1-2.92-1,3.45,3.45,0,0,1-.6-2.51,1.87,1.87,0,1,0-3.69-.64,6.58,6.58,0,0,0,7.21,7.86c7.7,0,8.53-4.92,8.53-7,0-4.95-3.9-6.26-6.24-7-.34-.11-.67-.22-1-.34-2.87-1.08-4.79-2.26-4.79-4.49C432.23,289.33,432.75,287.44,436.6,287.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M612.33,296c-.34-.11-.67-.22-1-.34-2.88-1.08-4.8-2.26-4.8-4.49,0-1.86.52-3.75,4.37-3.75a3.6,3.6,0,0,1,3.91,3.76,1.88,1.88,0,0,0,3.75,0,7.36,7.36,0,0,0-7.66-7.5c-5.08,0-8.12,2.8-8.12,7.5,0,5.28,5.25,7.26,7.23,8l1.12.39c2.61.87,3.68,1.43,3.68,3.48,0,1,0,3.28-4.79,3.28a3.73,3.73,0,0,1-2.92-1,3.5,3.5,0,0,1-.6-2.51,1.87,1.87,0,1,0-3.69-.64,6.59,6.59,0,0,0,7.21,7.86c7.71,0,8.54-4.92,8.54-7C618.57,298.11,614.67,296.8,612.33,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.63,304.51a2.56,2.56,0,1,0,2.55,2.56A2.56,2.56,0,0,0,177.63,304.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.37,283.69H217.66a1.88,1.88,0,0,0-1.87,1.88v22.64a1.88,1.88,0,0,0,1.87,1.88,1.77,1.77,0,0,1,1.67,0H231.2c4.51,0,6.87-3.92,6.87-7.79,0-2.84-.81-4.61-2-5.71a8.53,8.53,0,0,0,2-5.61C238.07,287.35,235.69,283.69,230.37,283.69Zm3.95,7.29c0,.16,0,4-3.12,4H219.54v-7.58h10.83C233.81,287.44,234.32,289.66,234.32,291Zm-3.12,15.36H219.54v-7.58h11.87c2.26,0,2.91.8,2.91,3.54C234.32,302.47,234.29,306.34,231.2,306.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.24,283.69h-12.7a1.88,1.88,0,0,0-1.88,1.88v22.64a1.88,1.88,0,0,0,3.76,0v-9.45h11.65c4.52,0,6.88-3.91,6.88-7.78C482,287.35,479.57,283.69,474.24,283.69Zm.83,11.33H463.42v-7.58h10.82c3.44,0,4,2.22,4,3.54C478.2,291.14,478.17,295,475.07,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.15,287.44a1.88,1.88,0,0,0,0-3.75H255.36a1.88,1.88,0,0,0-1.87,1.88v22.64a1.88,1.88,0,0,0,1.87,1.88h14.79a1.88,1.88,0,0,0,0-3.75H257.23v-7.58h10.42a1.87,1.87,0,0,0,0-3.74H257.23v-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.63,287.44a1.88,1.88,0,1,0,0-3.75H287.85a1.88,1.88,0,0,0-1.88,1.88v22.64a1.88,1.88,0,0,0,1.88,1.88h14.78a1.88,1.88,0,1,0,0-3.75H289.72v-7.58h10.42a1.87,1.87,0,0,0,0-3.74H289.72v-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.31,298.72c4-.43,6.08-4.1,6.08-7.74s-2.38-7.29-7.71-7.29H321a1.88,1.88,0,0,0-1.87,1.88v22.64a1.87,1.87,0,1,0,3.74,0v-9.45h7.95L338,309.27a1.87,1.87,0,1,0,3.09-2.11Zm-12.46-11.28h10.83c3.45,0,4,2.22,4,3.54,0,.16,0,4-3.12,4H322.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.77,298.72c4-.43,6.08-4.1,6.08-7.74s-2.38-7.29-7.7-7.29H537.44a1.88,1.88,0,0,0-1.87,1.88v22.64a1.88,1.88,0,1,0,3.75,0v-9.45h7.94l7.17,10.51a1.87,1.87,0,0,0,1.55.82,1.92,1.92,0,0,0,1.06-.33,1.88,1.88,0,0,0,.49-2.6Zm-12.45-11.28h10.83c3.44,0,4,2.22,4,3.54,0,.16,0,4-3.12,4H539.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.19,283.69c-8.22,0-13.95,5.43-13.95,13.2,0,8.67,7,13.2,13.95,13.2,7.26,0,14.58-4.09,14.58-13.2C522.77,288.23,515.43,283.69,508.19,283.69Zm0,22.65c-5.08,0-10.2-2.93-10.2-9.45,0-5.74,4-9.45,10.2-9.45,5.38,0,10.83,3.25,10.83,9.45C519,303.86,513.42,306.34,508.19,306.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.24,283.69H569.63a1.88,1.88,0,1,0,0,3.75h8.43v20.77a1.88,1.88,0,1,0,3.75,0V287.44h8.43a1.88,1.88,0,1,0,0-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.6,294.1h-7.39a3.75,3.75,0,0,1-3.85-3.33c0-1.55.44-3.33,3.85-3.33s3.61,3.22,3.65,3.87a1.83,1.83,0,0,0,1.94,1.79,1.87,1.87,0,0,0,1.8-1.94c-.09-2.58-1.76-7.47-7.39-7.47-4.76,0-7.6,2.65-7.6,7.08a6.71,6.71,0,0,0,1.77,4.48,7.57,7.57,0,0,0-3.64,6.74c0,5.22,2.88,8.1,8.12,8.1,4.86,0,8.12-3.58,8.12-8.9v-3.34h.62a1.88,1.88,0,1,0,0-3.75Zm-4.37,7.09c0,1.54-.43,5.15-4.37,5.15-3.15,0-4.38-1.22-4.38-4.35a4.38,4.38,0,0,1,4-4.34,7.76,7.76,0,0,0,1.75.2h3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.02 370.98 348.02 412.18 335.98 391.44 348.07 349.89 360.02 370.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "374.1 395.84 362.23 436.62 350.62 416.66 350.62 416.65 362.6 375.53 374.1 395.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.07 422.24 389.07 422.25 377.31 462.6 364.83 441.11 376.67 400.38 389.07 422.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "402.53 446.02 392.88 489.39 379.92 467.07 391.64 426.8 402.53 446.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "331.76 321.1 345.49 345.33 333.38 386.96 320.98 365.63 331.76 321.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.31 352.26 349.82 342.83 337.18 320.51 378.31 333.36 389.31 352.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "404.94 379.17 365 369.62 352.35 347.29 391.9 356.75 404.94 379.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.97 403.31 378.61 393.65 367.53 374.08 407.54 383.64 418.97 403.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "434.49 430.02 393.68 420.25 381.13 398.11 421.57 407.78 421.57 407.79 434.49 430.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "449.85 456.44 406.78 443.36 396.22 424.72 437.1 434.51 449.85 456.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "256.26 370.98 268.26 412.18 280.31 391.44 268.21 349.89 256.26 370.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "242.18 395.84 254.05 436.62 265.66 416.66 265.66 416.65 253.68 375.53 242.18 395.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.21 422.24 227.21 422.25 238.97 462.6 251.45 441.11 239.61 400.38 227.21 422.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.75 446.02 223.4 489.39 236.36 467.07 224.64 426.8 213.75 446.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.52 321.1 270.79 345.33 282.9 386.96 295.3 365.63 284.52 321.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.98 352.26 266.46 342.83 279.1 320.51 237.97 333.36 226.98 352.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "211.34 379.17 251.28 369.62 263.94 347.29 224.38 356.75 211.34 379.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.31 403.31 237.67 393.65 248.75 374.08 208.74 383.64 197.31 403.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.79 430.02 222.6 420.25 235.15 398.11 194.71 407.78 194.71 407.79 181.79 430.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.44 456.44 209.5 443.36 220.06 424.72 179.18 434.51 166.44 456.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.02 118.41 348.02 77.21 335.98 97.95 348.07 139.5 360.02 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "374.1 93.56 362.23 52.77 350.62 72.73 350.62 72.74 362.6 113.86 374.1 93.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.07 67.15 389.07 67.14 377.31 26.79 364.83 48.28 376.67 89.01 389.07 67.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "402.53 43.37 392.88 0 379.92 22.32 391.64 62.59 402.53 43.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "331.76 168.29 345.49 144.06 333.38 102.43 320.98 123.76 331.76 168.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.31 137.13 349.82 146.56 337.18 168.88 378.31 156.03 389.31 137.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "404.94 110.22 365 119.77 352.35 142.1 391.9 132.64 404.94 110.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.97 86.08 378.61 95.74 367.53 115.31 407.54 105.75 418.97 86.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "434.49 59.37 393.68 69.14 381.13 91.28 421.57 81.61 421.57 81.6 434.49 59.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "449.85 32.95 406.78 46.03 396.22 64.67 437.1 54.88 449.85 32.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "256.26 118.41 268.26 77.21 280.31 97.95 268.21 139.5 256.26 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "242.18 93.56 254.05 52.77 265.66 72.73 265.66 72.74 253.68 113.86 242.18 93.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.21 67.15 227.21 67.14 238.97 26.79 251.45 48.28 239.61 89.01 227.21 67.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.75 43.37 223.4 0 236.36 22.32 224.64 62.59 213.75 43.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.52 168.29 270.79 144.06 282.9 102.43 295.3 123.76 284.52 168.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.98 137.13 266.46 146.56 279.1 168.88 237.97 156.03 226.98 137.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "211.34 110.22 251.28 119.77 263.94 142.1 224.38 132.64 211.34 110.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.31 86.08 237.67 95.74 248.75 115.31 208.74 105.75 197.31 86.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.79 59.37 222.6 69.14 235.15 91.28 194.71 81.61 194.71 81.6 181.79 59.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.44 32.95 209.5 46.03 220.06 64.67 179.18 54.88 166.44 32.95"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e1e02a66a19844b168e074aeb294ecac.svg";
export { ForwardRef as ReactComponent };